var map = {
	"./01.jpg": 1823,
	"./02.jpg": 8546,
	"./03.jpg": 6537,
	"./04.jpg": 8655,
	"./05.jpg": 2126,
	"./06.jpg": 9173,
	"./07.jpg": 6260,
	"./08.jpg": 5609
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1490;